import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'sd-delivery-address-options',
  templateUrl: './delivery-address-options.component.html',
  styleUrls: ['./delivery-address-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryAddressOptionsComponent {
  readonly onEdit = input<(event: Event) => void>();
  readonly onDelete = input<() => void>();
}
